import { Component } from "@angular/core";

@Component({
  selector: "app-progress-spinner-v2",
  templateUrl: "./progress-spinner-v2.component.html",
  styleUrls: ["./progress-spinner-v2.component.scss"],
  standalone: false,
})
export class ProgressSpinnerV2Component {}
